<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p style="text-indent:00em; padding-top:15px;">Heartfelt gratitude to John Tagholm, Richard White and Caroline Davis, the special people who read the draft of my novel and offered me wise and constructive critical comments.</p>
<p style="text-indent:00em; padding-top:15px;">Two publications, compiled by Hilary Heffernan <em>The Annual Hop London to Kent</em> (1996 Tempus) and <em>Voices of Kent Hop Pickers</em> (1999 Tempus) informed my understanding of hop picking with background information and pictorial history.</p>
<p style="text-indent:00em; padding-top:15px;">My grateful thanks to Jane Feaver, Sam North and Andy Brown, my tutors on the Masters course in creative writing at Exeter University for giving me a much better understanding of literature and encouraging my literary aspirations.</p>
<p style="text-indent:00em; padding-top:15px;">Thanks to my wife Margaret, daughters Lucy and Oonagh and extended family for their loving encouragement and support.</p>
<p style="text-indent:00em; padding-top:15px;">Thanks to Austin Macauley, my publishers.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?28608355